import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorHandlerService } from '../error-handler.service';
import {
  EventOptionsBuilder,
  GoogleAnalyticsService
} from '../google-analytics-service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private googleAnalyticsService: GoogleAnalyticsService, private error: ErrorHandlerService) {}

  handleError(error: any) {
    if (!error) {
      return;
    }

    const eventOptionsBuilder = new EventOptionsBuilder({
      category: 'SSO Authentication',
      nonInteraction: true,
      page: window.location.toString(),
      action: '',
      label: '',
    });

    if (error instanceof HttpErrorResponse) {
      //API ERROR
      eventOptionsBuilder.setAction('UNKNOWN API ERROR');
      eventOptionsBuilder.setLabel(
        `URL:${error.url}:STATUS:${error.status}:STATUSMESSAGE:${error.statusText}`
      );
    } else if (error.rejection) {
      //PROMISE REJECTION
      eventOptionsBuilder.setAction('UNKNOWN ERROR').setLabel(`Error message: ${error.rejection}`);
    } else {
      eventOptionsBuilder
        .setAction('UNKNOWN ERROR')
        .setLabel(`Error message: ${JSON.stringify}`);
    }

    this.googleAnalyticsService.sendEvent(eventOptionsBuilder.getResult());
    this.error.navigateToErrorPage();
  }
}
